import { type ComponentRef, ApplicationRef, NgModuleRef } from '@angular/core';
import React, { ForwardedRef } from 'react';
import { useInjector } from '../../hooks/use-injector';
import { AngularWrapperWithModule } from '@box-react/components/angular-wrapper-with-module';

function AngularWrapper(props: {
  name?: string;
  component: any;
  inputs?: Record<string, any>;
  events?: Record<string, (ev: Event) => any>;
  outputs?: Record<string, (value: any) => any>;
  children?: any;
  className?: any;
  ref?: ForwardedRef<ComponentRef<any>>;
}) {
  const injector = useInjector();
  const appRef = useInjector().get(ApplicationRef);
  const moduleRef: NgModuleRef<unknown> = appRef.components[0].injector.get(NgModuleRef);

  return (
    <AngularWrapperWithModule
      name={props.name}
      component={props.component}
      moduleRef={moduleRef}
      injector={injector}
      inputs={props.inputs}
      events={props.events}
      outputs={props.outputs}
      ref={props.ref}
      className={props.className}
    >
      {props.children}
    </AngularWrapperWithModule>
  );
}

export { AngularWrapper };
